module.exports = __webpack_public_path__ + "static/media/dropbox.89edcdea.png";